import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`

  /*@import url('https://fonts.googleapis.com/css2?family=Hind&family=Roboto+Flex&display=swap');*/

  :root {

    /* Z-Index Scale */
    /* WHY: Single source of truth for stacking context. Prevents z-index arms race.
       Layers are spaced to allow insertion without renumbering.
       Migration: replace hardcoded values with these tokens one component at a time. */
    --z-index-dropdown: 100;
    --z-index-sticky: 200;
    --z-index-modal: 1000;
    --z-index-modal-banner: 1001;
    --z-index-overlay: 9999;       /* Full-screen overlays: checkout, auth, spinners */
    --z-index-auth-layout: 10000;  /* Auth flows sit above all app content */
    --z-index-player: 2147483003;  /* Video player: near browser max for fullscreen */

    /* Box Shadows */
    --shadow-button: 0px 2px 10px 0px rgba(0, 0, 0, 0.3),
    0px 1px 2px 0px rgba(0, 0, 0, 0.2);
    --shadow-button-medium: 0px 1px 2px 0px rgba(0, 0, 0, 0.2);
    --card: 0px 5px 10px 0px rgba(51, 59, 65, 0.1),
    0px 1px 3px 0px rgba(0, 0, 0, 0.15);
    --shadow-card-hero: 0px 10px 15px -10px rgba(51, 59, 65, 0.2),
    0px 20px 60px 0px rgba(0, 0, 0, 0.5);
    --shadow-card-hover: 0px 10px 20px 0px rgba(51, 59, 65, 0.2),
    0px 1px 5px 0px rgba(0, 0, 0, 0.25);
    --controls-button-font-family: "Inter-ExtraBold", Helvetica;
    --controls-button-font-size: 20px;
    --controls-button-font-style: normal;
    --controls-button-font-weight: var(--font-weight-800);
    --controls-button-letter-spacing: 0.6px;
    --controls-button-line-height: 24px;
    --controls-button-small-font-family: "Inter-ExtraBold", Helvetica;
    --controls-button-small-font-size: 16px;
    --controls-button-small-font-style: normal;
    --controls-button-small-font-weight: var(--font-weight-800);
    --controls-button-small-letter-spacing: 0.48px;
    --controls-button-small-line-height: 24px;
    --controls-field-input-font-family: "Inter", Helvetica;
    --controls-field-input-font-size: 16px;
    --controls-field-input-font-style: normal;
    --controls-field-input-font-weight: var(--font-weight-400);
    --controls-field-input-letter-spacing: 0px;
    --controls-field-input-line-height: 125%;
    --controls-field-label-font-family: "Inter", Helvetica;
    --controls-field-label-font-size: 14px;
    --controls-field-label-font-style: normal;
    --controls-field-label-font-weight: var(--font-weight-400);
    --controls-field-label-letter-spacing: 0px;
    --controls-field-label-line-height: 125%;
    --controls-footer-link-font-family: "Inter", Helvetica;
    --controls-footer-link-font-size: 12px;
    --controls-footer-link-font-style: normal;
    --controls-footer-link-font-weight: var(--font-weight-400);
    --controls-footer-link-letter-spacing: 0px;
    --controls-footer-link-line-height: 16px;
    --controls-label-font-family: "Inter", Helvetica;
    --controls-label-font-size: 12px;
    --controls-label-font-style: normal;
    --controls-label-font-weight: var(--font-weight-600);
    --controls-label-letter-spacing: 0.36px;
    --controls-label-line-height: 120.00000476837158%;
    --controls-menu-link-font-family: "Inter", Helvetica;
    --controls-menu-link-font-size: 14px;
    --controls-menu-link-font-style: normal;
    --controls-menu-link-font-weight: var(--font-weight-700);
    --controls-menu-link-letter-spacing: 0.5px;
    --controls-menu-link-line-height: 16px;
    --controls-menu-link-small-bold-font-family: "Inter-SemiBold", Helvetica;
    --controls-menu-link-small-bold-font-size: 12px;
    --controls-menu-link-small-bold-font-style: normal;
    --controls-menu-link-small-bold-font-weight: var(--font-weight-600);
    --controls-menu-link-small-bold-letter-spacing: 0px;
    --controls-menu-link-small-bold-line-height: 16px;
    --controlsmodal: rgba(51, 59, 65, 0.8);
    --controlspadding-setting: rgba(255, 255, 255, 0);
    --dropdown-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.04);
    --guides-label-font-family: "Inter-Regular", Helvetica;
    --guides-label-font-size: 8px;
    --guides-label-font-style: normal;
    --guides-label-font-weight: var(--font-weight-400);
    --guides-label-letter-spacing: 0px;
    --guides-label-line-height: 100%;
    --headings-h1-font-family: "Inter", Helvetica;
    --headings-h1-font-size: 60px;
    --headings-h1-font-style: normal;
    --headings-h1-font-weight: var(--font-weight-700);
    --headings-h1-letter-spacing: -0.6px;
    --headings-h1-line-height: 120.00000476837158%;
    --headings-h1-mobile-font-family: "Inter", Helvetica;
    --headings-h1-mobile-font-size: 34px;
    --headings-h1-mobile-font-style: normal;
    --headings-h1-mobile-font-weight: var(--font-weight-700);
    --headings-h1-mobile-letter-spacing: 0px;
    --headings-h1-mobile-line-height: 114.99999761581421%;
    --headings-h2-font-family: "Inter", Helvetica;
    --headings-h2-font-size: 52px;
    --headings-h2-font-style: normal;
    --headings-h2-font-weight: var(--font-weight-700);
    --headings-h2-letter-spacing: 0px;
    --headings-h2-line-height: 125%;
    --headings-h2-mobile-font-family: "Inter", Helvetica;
    --headings-h2-mobile-font-size: 32px;
    --headings-h2-mobile-font-style: normal;
    --headings-h2-mobile-font-weight: var(--font-weight-700);
    --headings-h2-mobile-letter-spacing: 0px;
    --headings-h2-mobile-line-height: 125%;
    --headings-h3-font-family: "Inter", Helvetica;
    --headings-h3-font-size: 38px;
    --headings-h3-font-style: normal;
    --headings-h3-font-weight: var(--font-weight-700);
    --headings-h3-letter-spacing: 0px;
    --headings-h3-line-height: 114.99999761581421%;
    --headings-h3-mobile-font-family: "Inter", Helvetica;
    --headings-h3-mobile-font-size: 26px;
    --headings-h3-mobile-font-style: normal;
    --headings-h3-mobile-font-weight: var(--font-weight-700);
    --headings-h3-mobile-letter-spacing: 0px;
    --headings-h3-mobile-line-height: 125%;
    --headings-h4-font-family: "Inter", Helvetica;
    --headings-h4-font-size: 2.4rem;
    --headings-h4-font-style: normal;
    --headings-h4-font-weight: var(--font-weight-700);
    --headings-h4-letter-spacing: -0.24px;
    --headings-h4-line-height: 125%;
    --headings-h4-mobile-font-family: "Inter", Helvetica;
    --headings-h4-mobile-font-size: 2rem;
    --headings-h4-mobile-font-style: normal;
    --headings-h4-mobile-font-weight: var(--font-weight-700);
    --headings-h4-mobile-letter-spacing: -0.2px;
    --headings-h4-mobile-line-height: 125%;
    --headings-h5-font-family: "Inter", Helvetica;
    --headings-h5-font-size: 18px;
    --headings-h5-font-style: normal;
    --headings-h5-font-weight: var(--font-weight-700);
    --headings-h5-letter-spacing: 0.54px;
    --headings-h5-line-height: 125%;
    --headings-h6-font-family: "Inter", Helvetica;
    --headings-h6-font-size: 14px;
    --headings-h6-font-style: normal;
    --headings-h6-font-weight: var(--font-weight-700);
    --headings-h6-letter-spacing: 0px;
    --headings-h6-line-height: 125%;
    --nav-on-scroll: 0px 3px 5px 0px rgba(0, 0, 0, 0.05);
    --neutralblack: rgba(0, 0, 0, 1);
    --neutralgrey-1: rgba(35, 35, 35, 1);
    --neutralgrey-2: rgba(65, 65, 65, 1);
    --neutralgrey-3: rgba(103, 103, 103, 1);
    --neutralgrey-4: rgba(171, 171, 171, 1);
    --neutralgrey-5: rgba(215, 215, 215, 1);
    --neutralgrey-6: rgba(235, 235, 235, 1);
    --neutralgrey-7: rgba(248, 248, 248, 1);
    --neutralwhite: rgba(255, 255, 255, 1);
    --opacityblack-10: rgba(0, 0, 0, 0.1);
    --opacityblack-20: rgba(0, 0, 0, 0.2);
    --opacityblack-50: rgba(0, 0, 0, 0.5);
    --paragraph-body-bold-font-family: "Inter", Helvetica;
    --paragraph-body-bold-font-size: 16px;
    --paragraph-body-bold-font-style: normal;
    --paragraph-body-bold-font-weight: var(--font-weight-700);
    --paragraph-body-bold-letter-spacing: 0px;
    --paragraph-body-bold-line-height: 150%;
    --paragraph-body-regular-font-family: "Inter", Helvetica;
    --paragraph-body-regular-font-size: 16px;
    --paragraph-body-regular-font-style: normal;
    --paragraph-body-regular-font-weight: var(--font-weight-400);
    --paragraph-body-regular-letter-spacing: 0px;
    --paragraph-body-regular-line-height: 150%;
    --paragraph-lead-bold-font-family: "Inter", Helvetica;
    --paragraph-lead-bold-font-size: 20px;
    --paragraph-lead-bold-font-style: normal;
    --paragraph-lead-bold-font-weight: var(--font-weight-700);
    --paragraph-lead-bold-letter-spacing: 0px;
    --paragraph-lead-bold-line-height: 129.99999523162842%;
    --paragraph-lead-regular-font-family: "Inter", Helvetica;
    --paragraph-lead-regular-font-size: 20px;
    --paragraph-lead-regular-font-style: normal;
    --paragraph-lead-regular-font-weight: var(--font-weight-400);
    --paragraph-lead-regular-letter-spacing: 0px;
    --paragraph-lead-regular-line-height: 129.99999523162842%;
    --paragraph-note-bold-font-family: "Inter", Helvetica;
    --paragraph-note-bold-font-size: 12px;
    --paragraph-note-bold-font-style: normal;
    --paragraph-note-bold-font-weight: var(--font-weight-700);
    --paragraph-note-bold-letter-spacing: 0px;
    --paragraph-note-bold-line-height: 150%;
    --paragraph-note-regular-font-family: "Inter", Helvetica;
    --paragraph-note-regular-font-size: 12px;
    --paragraph-note-regular-font-style: normal;
    --paragraph-note-regular-font-weight: var(--font-weight-400);
    --paragraph-note-regular-letter-spacing: 0px;
    --paragraph-note-regular-line-height: 150%;
    --paragraph-quote-font-family: "Inter", Helvetica;
    --paragraph-quote-font-size: 36px;
    --paragraph-quote-font-style: normal;
    --paragraph-quote-font-weight: var(--font-weight-700);
    --paragraph-quote-letter-spacing: 0px;
    --paragraph-quote-line-height: 125%;
    --paragraph-quote-mobile-font-family: "Inter", Helvetica;
    --paragraph-quote-mobile-font-size: 24px;
    --paragraph-quote-mobile-font-style: normal;
    --paragraph-quote-mobile-font-weight: var(--font-weight-700);
    --paragraph-quote-mobile-letter-spacing: 0px;
    --paragraph-quote-mobile-line-height: 125%;
    --systemblue: rgba(42, 114, 245, 1);
    --systemgreen: rgba(25, 244, 178, 1);
    --systemorange: rgba(247, 147, 26, 1);
    --systempurple: rgba(90, 63, 255, 1);
    --systemred: rgba(255, 39, 75, 1);
    /* --theme-action-primary: #2F34FE; */
    --theme-action-primary: #2F34FE; /* Default blue, overridden by channel theme */
    --theme-action-primary-hover: #2529D6; /* Darker blue for hover state */
    --theme-action-secondary: rgba(0, 0, 0, 1);
    --theme-assets-recolour: rgba(103, 103, 103, 1);
    --theme-background-primary: #2F34FE;
    --theme-background-secondary: rgba(255, 255, 255, 1);
    --theme-background-tertiary: rgba(248, 248, 248, 1);
    --transparencywhite-20: rgba(255, 255, 255, 0.2);
    --transparencywhite-30: rgba(255, 255, 255, 0.3);
    --transparencywhite-50: rgba(255, 255, 255, 0.5);
    --transparencywhite-80: rgba(255, 255, 255, 0.8);

    --font-family-sans-serif: "Inter", Helvetica, sans-serif;

    --theme-font-family: "Inter", Helvetica, sans-serif;
    --theme-text-color: #fff;


    --color-grey-0: #fff;
    --color-grey-50: #f9fafb;
    --color-grey-100: #F8F8F8;
    --color-grey-200: #e5e7eb;
    --color-grey-300: #d1d5db;
    --color-grey-400: #9ca3af;
    --color-grey-500: #6b7280;
    --color-grey-600: #4b5563;
    --color-grey-700: #414141;
    --color-grey-800: #1f2937;
    --color-grey-900: #232323;

    --color-black-900: #111;

    --color-blue-100: #e0f2fe;
    --color-blue-700: #0369a1;
    --color-green-100: #dcfce7;
    --color-green-700: #15803d;
    --color-yellow-100: #fef9c3;
    --color-yellow-700: #a16207;
    --color-silver-100: #e5e7eb;
    --color-silver-700: #374151;
    --color-indigo-100: #e0e7ff;
    --color-indigo-700: #4338ca;

    --color-red-100: #fee2e2;
    --color-red-600: #cc1720;
    --color-red-700: #b91c1c;
    --color-red-800: #991b1b;

    --backdrop-color: rgba(255, 255, 255, 0.1);
    --backdrop-color-dark: rgba(0, 0, 0, 0.4);

    --color-error-background: #fee2e2;
    --color-error-light: #D32F2F;
    --color-error-dark: #991b1b;
    
    --color-success-dark: #15803d; 
    --color-success-light: #15803d;
    --color-success-background: #dcfce7;
    --color-focus: #2A72F5;

    --text-primary: rgba(255, 255, 255, 1.0);
    --text-secondary: rgba(255, 255, 255, 0.8);
    --text-tertiary: rgba(255, 255, 255, 0.6);

    --color-neutral-dark-100: #16181e;
    --color-neutral-dark-300: #33353C;

    --color-surface-primary: #131419;
    --color-surface-secondary: #16181e;
    --color-surface-success: #23A36D;
    --color-surface-success-pale: rgba(35, 163, 109, 0.33);
    --color-surface-scrim: rgba(19, 20, 25, 0.7);
    --color-surface-icon: rgba(19, 20, 25, 0.3);
    --color-surface-action-neutral: #262935;
    --color-surface-action-neutral-hover: rgba(255, 255, 255, 0.05);
    --color-surface-quaternary: rgba(51, 53, 60, 1);

    --surface-action-neutral-disabled: rgba(255, 255, 255, 0.02);
    --surface-action-neutral: #262935;

    --color-live: #FF1637;

    --text-disabled: rgba(255, 255, 255, 0.4);

    --border-primary:rgba(255, 255, 255, 0.20);
    --border-error: #e34935;
    --icon-error: rgba(227, 73, 53, 1);

    --radius-sm: 4px;
    --radius-md: 8px;

    --spacing-sm: 12px;
    --spacing-xxs: 4px;

    --font-weight-200: 100;
    --font-weight-300: 200;
    --font-weight-400: 300;
    --font-weight-500: 400;
    --font-weight-600: 500;
    --font-weight-700: 600;
    --font-weight-800: 700;
    --font-weight-900: 800;

    --spacing-md: 16px;

  }


  *,
  *::before,
  *::after {
    box-sizing: border-box;
    padding: 0;
    margin: 0;

    /* Creating animations for dark mode */
    transition: background-color 0.3s, border 0.3s;
  }

  html {
    font-size: 62.5%;
    scroll-behavior: smooth;
  }

  body {
    font-family: "Inter", Helvetica, sans-serif;
    color: var(--color-grey-700);
    min-height: 100vh;
    line-height: 1.5;
    font-size: 1.6rem;
    background-color: var(--color-surface-primary);
    overscroll-behavior: none;
    overflow-x: hidden;

  }

  input,
  button,
  textarea,
  select {
    font: inherit;
    color: inherit;
  }

  /* WHY: Reset input default styling to prevent browser defaults from interfering
     Ensures inputs are styled by their parent containers (FormInputBox, etc.)
     Prevents black/white browser defaults from showing */
  input {
    background-color: transparent;
    border: none;
    outline: none;
  }

  input:disabled {
    background-color: transparent;
  }

  /* WHY: Override browser autofill yellow background for dark theme compatibility
     Using dark background color to match app theme instead of white
     This global style ensures all inputs across the app have consistent autofill styling */
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 1000px #16181e inset !important;
    -webkit-text-fill-color: rgba(255, 255, 255, 1) !important;
    transition: background-color 5000s ease-in-out 0s;
    caret-color: rgba(255, 255, 255, 1);
  }


  

  a {
    text-decoration: none;
    color: inherit;
  }

  .player-showing {
    overflow-y: hidden;
  }

  .no-scroll {
    overflow-y: hidden;
  }


  /* CookieYes Hide When player is showing */
  .player-showing .cky-btn-revisit-wrapper {
    z-index: -1;
}
  


  .hide-info {
    visibility: hidden;
    opacity: 0;
    max-height: 0;
    transition: 0.5s ease-in;
    overflow: hidden;
    margin: 0;
    padding: 0;
  }

  .show-fixture-info {
    visibility: visible;
    opacity: 1;
    max-height: 200px;
    transition: 0.5s ease-out;
  }

  .hide-fixture-info {
    visibility: hidden;
    opacity: 0;
    max-height: 0;
    transition: 0.5s ease-in;
    overflow: hidden;
    margin: 0;
    padding: 0;
  }

  .show-info {
    visibility: visible;
    opacity: 1;
    max-height: 200px;
    transition: 0.5s ease-out;
  }

  .hide-accordian {
    visibility: hidden;
    opacity: 0;
    max-height: 0;
    transition: all 0.5s ease-out;
    overflow: hidden;
    margin: 0;
    padding: 0 2.4rem !important;
  }

  .show-accordian {
    visibility: visible;
    opacity: 1;
    max-height: 500px; /* Generous ceiling for FAQ content; must be numeric for CSS transition from 0 */
    transition: all 0.5s ease-out;
  }

  .swiper {
    overflow-y: visible;
    overflow-x: clip;
   
  }

  /* WHY: MUI Skeleton does not respect prefers-reduced-motion (upstream issue #16367).
     Disable wave/pulse animations globally for users who prefer reduced motion. */
  @media (prefers-reduced-motion: reduce) {
    .MuiSkeleton-root {
      animation: none !important;
    }
  }

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }

  @media screen and (max-width: 479px) {
    .swiper  .card-body {
       width: 18rem;
  }

  .swiper  .swiper-slide{
       display: flex;
       justify-content: center;
       transition: all .4s ease;             
  }

  .swiper  .swiper-slide.swiper-slide-prev{
        transform: translateX(15%);
  }  

  .swiper  .swiper-slide.swiper-slide-next{
        transform: translateX(-15%);
  }
}



 

  @media screen and (max-width: 479px) {
    section#pricing {
      padding-left: 0;
      padding-right: 0;
    }
    section#about {
      padding-left: 0;
      padding-right: 0;
      padding-bottom: 12rem;
    }
  }
`;

export default GlobalStyles;
